import { AutoMap } from "@automapper/classes";


export class ProcessSamplingConditionDTO {

    @AutoMap()
    apr!: number;
    @AutoMap()
    temoin!: string;
    @AutoMap()
    hygrometrie1!: number;
    @AutoMap()
    hygrometrie2!: number;
    @AutoMap()
    hygrometrie3!: number;
    @AutoMap()
    vitesseVent1!: number;
    @AutoMap()
    vitesseVent2!: number;
    @AutoMap()
    vitesseVent3!: number;
    @AutoMap()
    meteo!: number;
    @AutoMap()
    expositionClimatique!: number;
}